/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Brightness_LabelInputs */



/**
* | output |
* | --- |
* | "Brightness" |
*
* @param {Video_Filters_Brightness_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_brightness_label = /** @type {((inputs?: Video_Filters_Brightness_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Brightness_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Luminosite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Helligkeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Luminosità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Яркость")
	if (locale === "es") return /** @type {LocalizedString} */ ("Brillo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("亮度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("輝度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चमक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Brilho")
	return /** @type {LocalizedString} */ ("Brightness")
});